import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserModel } from '../../_models/user.model';
import { environment } from '../../../../../environments/environment';
import { AuthModel } from '../../_models/auth.model';
import { catchError, switchMap, tap } from 'rxjs/operators';

const API_USERS_URL = `${environment.apiUrl}auth/login`;
const API_USERS_URL_REFRESH_TOKEN = `${environment.apiUrl}auth/refresh-token`;
const API_USER_URL_LOGOUT = `${environment.apiUrl}auth/logout`
const API_USER_URL_REQUEST_PASSWORD = `${environment.apiUrl}auth/request-password`

const API_DOUBLE_AUTH_LOGIN = `${environment.apiUrl}auth/doubleauthlogin`;
const API_SEND_PIN_BY_EMAIL = `${environment.apiUrl}auth/sendpinbyemail`;
const API_SEND_PIN_BY_SMS = `${environment.apiUrl}auth/sendpinbysms`;

const API_CSRF_COOKIE = `${environment.apiUrl}csrf-cookie`;


@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {

  constructor(private http: HttpClient) {
    // console.log(environment.apiUrl);
    // this.http.get(API_CSRF_COOKIE).subscribe();
  }


  // private getCookie(name: string) {
  //   const value = `; ${document.cookie}`;
  //   const parts = value.split(`; ${name}=`);
  //   if (parts.length === 2) return parts.pop()?.split(';').shift();
  //   return null;
  // }

  getCsrfCookie() {
    return this.http.get(API_CSRF_COOKIE, {
      // withCredentials: true
    }).pipe(
      tap(response => {
        console.log('CSRF Response:', response);
        
      })
    );
  }
  /**
   * 
   * @param identifiant 
   * @param password 
   * @param url 
   */
  login(identifiant: string, password: string, url: string): Observable<any> {
    let body = {
      identifiant, password, url
    };
    let result = this.http.post<AuthModel>(API_USERS_URL,
      body,{
        // withCredentials: true,
        observe: 'response'
      }
    );

    return result;
  }

  /**
   * 
   * @param identifiant 
   * @param password 
   * @param url 
   */
  loginV2(identifiant: string, password: string, url: string): Observable<any> {
    let body = {
      identifiant, password, url
    };

    return this.getCsrfCookie().pipe(
      switchMap(() => this.http.post<AuthModel>(
        API_USERS_URL, body, { 
          // withCredentials: true, 
          observe: 'response' }))
    )
  }

  doubleAuthLogin(data) {
    return this.http.post(API_DOUBLE_AUTH_LOGIN, data,
      { observe: 'response' })
  }

  sendPinByEmail(data) {
    return this.http.post(API_SEND_PIN_BY_EMAIL,
      data,
      { observe: 'response' }
    );
  }

  sendPinBySMS(data) {
    return this.http.post(API_SEND_PIN_BY_SMS,
      data,
      { observe: 'response' }
    );
  }

  /**
   * 
   */
  loginFongesoft(token, url: string): Observable<any> {
    let body = {
      url
    };

    let result = this.http.post<AuthModel>(API_USERS_URL,
      body, { headers: { "X-login-fongesoft": token } }
    );

    return result;
  }

  /**
   * 
   * @param refreshToken 
   */
  refreshToken(refreshToken: string): Observable<any> {
    let body = { refreshToken, url: window.location.hostname };
    let result = this.http.post<any>(API_USERS_URL_REFRESH_TOKEN,
      body
    );

    return result;
  }

  /**
   * 
   */
  logout(): Observable<any> {

    // let toks = JSON.parse(localStorage.getItem(`${environment.appVersion}-${environment.USERDATA_KEY}`));

    // if (toks !== null) {
    //   let token = toks.accessToken;
    //   const headers = { 'Authorization': 'Bearer ' + token };
    //   this.http.post<any>(API_USER_URL_LOGOUT,
    //     {}, { headers }
    //   ).subscribe((b) => { return b });
    // } else {
    //   return of(null);
    // }
    return this.http.post<AuthModel>(
      API_USER_URL_LOGOUT, {}, { 
        // withCredentials: true, 
        observe: 'response' })


  }


  createUser(user: UserModel): Observable<UserModel> {
    return this.http.post<UserModel>(API_USERS_URL, user);
  }


  forgotPassword(email: string, url: string): Observable<boolean> {
    return this.http.post<boolean>(API_USER_URL_REQUEST_PASSWORD,
      { email: email, url: url });
  }

  getUserByToken(token): Observable<UserModel> {
    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return this.http.get<UserModel>(`${API_USERS_URL}`, {
      headers: httpHeaders,
    });
  }
}
